import { api } from '@setplex/tria-api'
import { attach, sample } from 'effector'
import { createForm } from 'effector-forms'
import { model as countryModel } from '~/entities/country'
import { minLength } from '~/shared/validators'

// sign up request effect
export const signInByPhoneFx = attach({
  effect: api.subscriber.signUpByPhoneFx,
})

// sign up form
export const signInByPhoneForm = createForm({
  fields: {
    phoneNumber: {
      init: '+' as string,
      rules: [minLength.validator(2)],
    },
  },
  validateOn: ['submit'],
})

// automatically set initial country code
sample({
  clock: countryModel.$phoneNumberCountyCode,
  fn: (code) => ({ phoneNumber: `+${code}` }),
  target: signInByPhoneForm.setInitialForm,
})

// automatically reset initial value if the field is empty
sample({
  clock: signInByPhoneForm.fields.phoneNumber.$value,
  filter: (phone) => phone === '',
  target: signInByPhoneForm.fields.phoneNumber.reset,
})

// send sign-up request
sample({
  clock: signInByPhoneForm.formValidated,
  target: signInByPhoneFx,
})
